import { render, staticRenderFns } from "./AttachmentVisibility.vue?vue&type=template&id=5674c8a7&"
import script from "./AttachmentVisibility.vue?vue&type=script&lang=js&"
export * from "./AttachmentVisibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports